/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `and` - and
 * * `or` - or
 * @export
 */
export const CustomQuestionnaireQuestionRuleOperatorEnum = {
  and: 'and',
  or: 'or',
} as const;
export type CustomQuestionnaireQuestionRuleOperatorEnum =
  (typeof CustomQuestionnaireQuestionRuleOperatorEnum)[keyof typeof CustomQuestionnaireQuestionRuleOperatorEnum];

export function instanceOfCustomQuestionnaireQuestionRuleOperatorEnum(value: any): boolean {
  for (const key in CustomQuestionnaireQuestionRuleOperatorEnum) {
    if (Object.prototype.hasOwnProperty.call(CustomQuestionnaireQuestionRuleOperatorEnum, key)) {
      if (
        (CustomQuestionnaireQuestionRuleOperatorEnum as Record<string, CustomQuestionnaireQuestionRuleOperatorEnum>)[
          key
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CustomQuestionnaireQuestionRuleOperatorEnumFromJSON(
  json: any,
): CustomQuestionnaireQuestionRuleOperatorEnum {
  return CustomQuestionnaireQuestionRuleOperatorEnumFromJSONTyped(json, false);
}

export function CustomQuestionnaireQuestionRuleOperatorEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireQuestionRuleOperatorEnum {
  return json as CustomQuestionnaireQuestionRuleOperatorEnum;
}

export function CustomQuestionnaireQuestionRuleOperatorEnumToJSON(
  value?: CustomQuestionnaireQuestionRuleOperatorEnum | null,
): any {
  return value as any;
}
